import React from "react";
import TwoFactorAuthillustrationIcon from "../../Assets/brand/TwoFactorAuthillustration.svg";

const TwoFactorAuthillustration: React.FC = () => {
  return (
    <div id="two-factor-auth-illustration-container" className="max-w-md">
      <img
        id="two-factor-auth-illustration-image"
        src={TwoFactorAuthillustrationIcon}
        alt="Two-factor authentication illustration"
        className="w-full h-auto"
      />
    </div>
  );
};

export default TwoFactorAuthillustration;
